/* NathanBuilds — interactions */
(function () {
  'use strict';

  /* Header : ombre au défilement */
  function header() {
    var h = document.querySelector('[data-header]');
    if (!h) return;
    var on = function () { h.classList.toggle('is-stuck', window.scrollY > 8); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* Menu mobile */
  function mobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    var scrim = document.querySelector('[data-scrim]');
    if (!nav) return;
    var open = function () { nav.classList.add('open'); scrim.classList.add('open'); document.body.style.overflow = 'hidden'; };
    var shut = function () { nav.classList.remove('open'); scrim.classList.remove('open'); document.body.style.overflow = ''; };
    document.querySelectorAll('[data-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-nav-close]').forEach(function (b) { b.addEventListener('click', shut); });
    scrim.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* Apparition au défilement */
  function reveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Galerie produit */
  function gallery() {
    var stage = document.querySelector('[data-stage]');
    if (!stage) return;
    document.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        stage.src = b.dataset.thumb;
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  }

  /* Quantité */
  function qty() {
    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = document.getElementById('Quantity');
        if (!input) return;
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10);
        input.value = Math.max(1, v);
      });
    });
  }

  /* Sélection des variantes */
  function variants() {
    var select = document.getElementById('VariantSelect');
    if (!select) return;

    function chosen() {
      var vals = [];
      document.querySelectorAll('[data-option-index]').forEach(function (g) {
        var a = g.querySelector('.opt.active');
        vals.push(a ? a.dataset.value : null);
      });
      return vals.join('||');
    }

    function apply() {
      var want = chosen(), match = null;
      Array.prototype.forEach.call(select.options, function (o) { if (o.dataset.options === want) match = o; });
      if (!match) return;
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      var now = document.querySelector('[data-price-now]');
      var was = document.querySelector('[data-price-was]');
      var save = document.querySelector('[data-price-save]');
      if (now) now.textContent = match.dataset.price;
      if (was) { was.textContent = match.dataset.was || ''; was.hidden = match.dataset.onsale !== '1'; }
      if (save) { save.textContent = match.dataset.save || ''; save.hidden = match.dataset.onsale !== '1'; }

      var btn = document.querySelector('[data-add]');
      var txt = document.querySelector('[data-add-text]');
      if (btn) {
        btn.disabled = match.dataset.available !== '1';
        if (txt) txt.textContent = match.dataset.available === '1' ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }
      var img = match.dataset.image, stage = document.querySelector('[data-stage]');
      if (img && stage) stage.src = img;
    }

    document.querySelectorAll('[data-option-index] .opt').forEach(function (o) {
      o.addEventListener('click', function () {
        o.parentElement.querySelectorAll('.opt').forEach(function (x) { x.classList.remove('active'); });
        o.classList.add('active');
        apply();
      });
    });
  }

  /* Bandeau défilant : duplique le contenu pour une boucle continue */
  function marquee() {
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      track.innerHTML += track.innerHTML;
    });
  }


  /* Barre d'achat collante : apparaît quand le bouton principal sort de l'écran */
  function buybar() {
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  document.addEventListener('DOMContentLoaded', function () {
    header(); mobileNav(); reveal(); gallery(); qty(); variants(); marquee(); buybar();
  });
})();
